module.exports = __webpack_public_path__ + "img/icons8-gefällt-mir.2509353e.svg";